import React from 'react';
import Title from '../Title';
import Stepper from './Stepper';
import { useTranslation } from 'react-i18next';

const StepperSection = () => {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col p-6 md:p-12 gap-6 md:gap-12'>
      <Title>{t('stepper.stepper_title')}</Title>
      <Stepper />
    </div>
  );
};

export default StepperSection;